import { locale as localeConfig } from '@adsk/au-common-js';

export function generateArticlePathname(slug: string, language?: string) {
  const langPrefix = localeConfig.generateLanguagePrefix(
    language || localeConfig.defaultURLLocale
  );

  const cleanLangPrefix = langPrefix.replace('/', '');

  const processedSlug = slug.replace('zh_hans/', 'zh-hans/'); // Cover the case where the slug has "zh_hans" with underscore
  const cleanSlug = processedSlug.replace(`${cleanLangPrefix}/`, '');

  return `/autodesk-university${langPrefix}/article/${cleanSlug}`;
}
